import { apiClient } from "../../api_client/api_client";

export interface EnableLogoutFAAResponseI {
  enable_logout_faa: boolean;
}

export interface AclSimpleI {
  aclCode: string;
  aclName: string;
}
export interface RoleAclSimpleI {
  roleName: string;
  roleCode: string;
  roleId: number;
  acls: AclSimpleI[];
}
export interface UserOrganizationSimpleI {
  organizationCode: string;
  organizationName: string;
  organizationId: number;
  fhirUri: string;
  roles: RoleAclSimpleI[];
}

const base = 'auth';

const Authpi = {
  isLogoutFromAllAppsEnabled: async () => apiClient.get<EnableLogoutFAAResponseI>(`${base}/is-logout-from-all-apps-enabled-for-frontend`),
  getUserSessionsRedirectUrl: () => apiClient.get<any>(`${base}/user-sessions`),
  getOrganizations: () => apiClient.get<UserOrganizationSimpleI[]>(`${base}/get-user-organizations`)
};

export const AuthService = {
  isLogoutFromAllAppsEnabled: async () => {
    const response = Authpi.isLogoutFromAllAppsEnabled();
    if(!response) return { enable_logout_faa: false };
    return response;
  },

  getUserSessionsRedirectUrl: () => {
    const response = Authpi.getUserSessionsRedirectUrl();
    if(!response) return undefined;
    return response;
  },

  getOrganizations: () => {
    const response = Authpi.getOrganizations();
    if(!response) return [];
    return response;
  }
};